export default __webpack_public_path__ + "static/media/bearshaman.640a1fcd.png";